import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "../../../hooks/useLocalizedPath";
import { Eye, Settings, Package, ArrowRight } from "lucide-react";
import { Section, Container, Button } from "../../ui";
import styles from "./FinalCTA.module.css";

const featureIcons = [Eye, Settings, Package];

interface FinalCTAProps {
  ns?: string;
  prefix?: string;
}

export function FinalCTA({ ns = "home", prefix = "finalCTA" }: FinalCTAProps) {
  const { t } = useTranslation(ns);
  const { lp } = useLocalizedPath();

  const features = t(`${prefix}.features`, { returnObjects: true }) as string[];

  return (
    <Section variant="light">
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.glow} />
          <div className={styles.content}>
            <h2 className={styles.title}>{t(`${prefix}.title`)}</h2>
            <p className={styles.subtitle}>{t(`${prefix}.subtitle`)}</p>
            <div className={styles.features}>
              {features.map((label, i) => {
                const Icon = featureIcons[i];
                return (
                  <div key={i} className={styles.feature}>
                    <Icon size={20} strokeWidth={1.5} />
                    <span>{label}</span>
                  </div>
                );
              })}
            </div>
            <div className={styles.actions}>
              <Button href={lp("/contact")} data-attr="cta-contact">{t(`${prefix}.cta`)}</Button>
              <a
                href="mailto:partners@qbp.solutions"
                className={styles.secondaryLink}
                data-attr="contact-email"
              >
                {t(`${prefix}.secondaryLink`)}
                <ArrowRight size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
